import { render, staticRenderFns } from "./ReviewDetailsCardNew.vue?vue&type=template&id=14e301ea"
import script from "./ReviewDetailsCardNew.vue?vue&type=script&lang=ts"
export * from "./ReviewDetailsCardNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14e301ea')) {
      api.createRecord('14e301ea', component.options)
    } else {
      api.reload('14e301ea', component.options)
    }
    module.hot.accept("./ReviewDetailsCardNew.vue?vue&type=template&id=14e301ea", function () {
      api.rerender('14e301ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reviews/ReviewDetailsCardNew.vue"
export default component.exports